/**
 * GENERATED FILE — DO NOT EDIT BY HAND.
 *
 * Run `bun run holidays:generate` instead. Source of truth is
 * `scripts/generate-holidays.ts`, which derives this from the `date-holidays` package
 * (a devDependency) so neither the Worker nor the Expo bundle has to carry it.
 *
 * US federal public holidays plus their observed substitute days, over
 * 2026–2040, plus any SBS-specific closures named in the generator.
 *
 * 185 days. Add a closure by editing SBS_EXTRA_CLOSURE_NAMES and re-running.
 */

/** Observed closures, as `YYYY-MM-DD` in the local business calendar (America/New_York). */
export const US_HOLIDAYS: ReadonlySet<string> = new Set([
	'2026-01-01', // New Year's Day
	'2026-01-19', // Martin Luther King Jr. Day
	'2026-02-16', // Washington's Birthday
	'2026-05-25', // Memorial Day
	'2026-06-19', // Juneteenth
	'2026-07-03', // Independence Day (substitute day)
	'2026-07-04', // Independence Day
	'2026-09-07', // Labor Day
	'2026-10-12', // Columbus Day
	'2026-11-11', // Veterans Day
	'2026-11-26', // Thanksgiving Day
	'2026-12-25', // Christmas Day
	'2027-01-01', // New Year's Day
	'2027-01-18', // Martin Luther King Jr. Day
	'2027-02-15', // Washington's Birthday
	'2027-05-31', // Memorial Day
	'2027-06-18', // Juneteenth (substitute day)
	'2027-06-19', // Juneteenth
	'2027-07-04', // Independence Day
	'2027-07-05', // Independence Day (substitute day)
	'2027-09-06', // Labor Day
	'2027-10-11', // Columbus Day
	'2027-11-11', // Veterans Day
	'2027-11-25', // Thanksgiving Day
	'2027-12-24', // Christmas Day (substitute day)
	'2027-12-25', // Christmas Day
	'2027-12-31', // New Year's Day (substitute day)
	'2028-01-01', // New Year's Day
	'2028-01-17', // Martin Luther King Jr. Day
	'2028-02-21', // Washington's Birthday
	'2028-05-29', // Memorial Day
	'2028-06-19', // Juneteenth
	'2028-07-04', // Independence Day
	'2028-09-04', // Labor Day
	'2028-10-09', // Columbus Day
	'2028-11-11', // Veterans Day
	'2028-11-23', // Thanksgiving Day
	'2028-12-25', // Christmas Day
	'2029-01-01', // New Year's Day
	'2029-01-15', // Martin Luther King Jr. Day
	'2029-02-19', // Washington's Birthday
	'2029-05-28', // Memorial Day
	'2029-06-19', // Juneteenth
	'2029-07-04', // Independence Day
	'2029-09-03', // Labor Day
	'2029-10-08', // Columbus Day
	'2029-11-11', // Veterans Day
	'2029-11-22', // Thanksgiving Day
	'2029-12-25', // Christmas Day
	'2030-01-01', // New Year's Day
	'2030-01-21', // Martin Luther King Jr. Day
	'2030-02-18', // Washington's Birthday
	'2030-05-27', // Memorial Day
	'2030-06-19', // Juneteenth
	'2030-07-04', // Independence Day
	'2030-09-02', // Labor Day
	'2030-10-14', // Columbus Day
	'2030-11-11', // Veterans Day
	'2030-11-28', // Thanksgiving Day
	'2030-12-25', // Christmas Day
	'2031-01-01', // New Year's Day
	'2031-01-20', // Martin Luther King Jr. Day
	'2031-02-17', // Washington's Birthday
	'2031-05-26', // Memorial Day
	'2031-06-19', // Juneteenth
	'2031-07-04', // Independence Day
	'2031-09-01', // Labor Day
	'2031-10-13', // Columbus Day
	'2031-11-11', // Veterans Day
	'2031-11-27', // Thanksgiving Day
	'2031-12-25', // Christmas Day
	'2032-01-01', // New Year's Day
	'2032-01-19', // Martin Luther King Jr. Day
	'2032-02-16', // Washington's Birthday
	'2032-05-31', // Memorial Day
	'2032-06-18', // Juneteenth (substitute day)
	'2032-06-19', // Juneteenth
	'2032-07-04', // Independence Day
	'2032-07-05', // Independence Day (substitute day)
	'2032-09-06', // Labor Day
	'2032-10-11', // Columbus Day
	'2032-11-11', // Veterans Day
	'2032-11-25', // Thanksgiving Day
	'2032-12-24', // Christmas Day (substitute day)
	'2032-12-25', // Christmas Day
	'2032-12-31', // New Year's Day (substitute day)
	'2033-01-01', // New Year's Day
	'2033-01-17', // Martin Luther King Jr. Day
	'2033-02-21', // Washington's Birthday
	'2033-05-30', // Memorial Day
	'2033-06-19', // Juneteenth
	'2033-06-20', // Juneteenth (substitute day)
	'2033-07-04', // Independence Day
	'2033-09-05', // Labor Day
	'2033-10-10', // Columbus Day
	'2033-11-11', // Veterans Day
	'2033-11-24', // Thanksgiving Day
	'2033-12-25', // Christmas Day
	'2033-12-26', // Christmas Day (substitute day)
	'2034-01-01', // New Year's Day
	'2034-01-02', // New Year's Day (substitute day)
	'2034-01-16', // Martin Luther King Jr. Day
	'2034-02-20', // Washington's Birthday
	'2034-05-29', // Memorial Day
	'2034-06-19', // Juneteenth
	'2034-07-04', // Independence Day
	'2034-09-04', // Labor Day
	'2034-10-09', // Columbus Day
	'2034-11-11', // Veterans Day
	'2034-11-23', // Thanksgiving Day
	'2034-12-25', // Christmas Day
	'2035-01-01', // New Year's Day
	'2035-01-15', // Martin Luther King Jr. Day
	'2035-02-19', // Washington's Birthday
	'2035-05-28', // Memorial Day
	'2035-06-19', // Juneteenth
	'2035-07-04', // Independence Day
	'2035-09-03', // Labor Day
	'2035-10-08', // Columbus Day
	'2035-11-11', // Veterans Day
	'2035-11-22', // Thanksgiving Day
	'2035-12-25', // Christmas Day
	'2036-01-01', // New Year's Day
	'2036-01-21', // Martin Luther King Jr. Day
	'2036-02-18', // Washington's Birthday
	'2036-05-26', // Memorial Day
	'2036-06-19', // Juneteenth
	'2036-07-04', // Independence Day
	'2036-09-01', // Labor Day
	'2036-10-13', // Columbus Day
	'2036-11-11', // Veterans Day
	'2036-11-27', // Thanksgiving Day
	'2036-12-25', // Christmas Day
	'2037-01-01', // New Year's Day
	'2037-01-19', // Martin Luther King Jr. Day
	'2037-02-16', // Washington's Birthday
	'2037-05-25', // Memorial Day
	'2037-06-19', // Juneteenth
	'2037-07-03', // Independence Day (substitute day)
	'2037-07-04', // Independence Day
	'2037-09-07', // Labor Day
	'2037-10-12', // Columbus Day
	'2037-11-11', // Veterans Day
	'2037-11-26', // Thanksgiving Day
	'2037-12-25', // Christmas Day
	'2038-01-01', // New Year's Day
	'2038-01-18', // Martin Luther King Jr. Day
	'2038-02-15', // Washington's Birthday
	'2038-05-31', // Memorial Day
	'2038-06-18', // Juneteenth (substitute day)
	'2038-06-19', // Juneteenth
	'2038-07-04', // Independence Day
	'2038-07-05', // Independence Day (substitute day)
	'2038-09-06', // Labor Day
	'2038-10-11', // Columbus Day
	'2038-11-11', // Veterans Day
	'2038-11-25', // Thanksgiving Day
	'2038-12-24', // Christmas Day (substitute day)
	'2038-12-25', // Christmas Day
	'2038-12-31', // New Year's Day (substitute day)
	'2039-01-01', // New Year's Day
	'2039-01-17', // Martin Luther King Jr. Day
	'2039-02-21', // Washington's Birthday
	'2039-05-30', // Memorial Day
	'2039-06-19', // Juneteenth
	'2039-06-20', // Juneteenth (substitute day)
	'2039-07-04', // Independence Day
	'2039-09-05', // Labor Day
	'2039-10-10', // Columbus Day
	'2039-11-11', // Veterans Day
	'2039-11-24', // Thanksgiving Day
	'2039-12-25', // Christmas Day
	'2039-12-26', // Christmas Day (substitute day)
	'2040-01-01', // New Year's Day
	'2040-01-02', // New Year's Day (substitute day)
	'2040-01-16', // Martin Luther King Jr. Day
	'2040-02-20', // Washington's Birthday
	'2040-05-28', // Memorial Day
	'2040-06-19', // Juneteenth
	'2040-07-04', // Independence Day
	'2040-09-03', // Labor Day
	'2040-10-08', // Columbus Day
	'2040-11-11', // Veterans Day
	'2040-11-22', // Thanksgiving Day
	'2040-12-25', // Christmas Day
]);

/**
 * The window this file actually covers.
 *
 * `isBusinessDay` THROWS outside it rather than guessing, because the alternative is the
 * quiet failure: past the last generated year every holiday becomes an ordinary business
 * day and every due date shifts a day early, with nothing to notice.
 * `tests/utils/business-days.spec.ts` fails once under two years remain.
 */
export const HOLIDAY_COVERAGE = { fromYear: 2026, toYear: 2040 } as const;
